var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_tools"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_tools",
    clipPath: "url(#clip-icon_tools)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M16.175,8.556,18.23,7.87l2.142-3.514-.707-.708-3.556,2.1L15.4,7.868l-6.071,6.07-1.1-1.1L4.555,16.564a2.016,2.016,0,1,0,2.853,2.85l3.675-3.724-1.022-1.021Zm-9.5,10.131a.984.984,0,1,1-1.389-1.4L8.237,14.3l1.391,1.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M14.52,11.668l-.73.73,4.9,4.9A.984.984,0,0,1,17.3,18.687l-4.9-4.9-.73.73,4.9,4.9a2.017,2.017,0,0,0,2.852-2.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M7.9,10.754l1.578,1.578.729-.73L8.184,9.575l-.307.107a2.894,2.894,0,0,1-.964.177A2.95,2.95,0,0,1,3.967,6.913a2.832,2.832,0,0,1,.022-.358L5.113,7.679a1.553,1.553,0,0,0,2.143,0l.422-.422a1.515,1.515,0,0,0,0-2.145L6.554,3.988a3.28,3.28,0,0,1,.359-.021A2.949,2.949,0,0,1,9.859,6.913a2.918,2.918,0,0,1-.177.965l-.106.306L11.6,10.21l.73-.73L10.754,7.9a3.75,3.75,0,0,0,.138-.99A3.982,3.982,0,0,0,6.913,2.936a3.935,3.935,0,0,0-1.554.315l-.7.3L6.949,5.843a.484.484,0,0,1,0,.683l-.422.422a.494.494,0,0,1-.685,0L3.55,4.656l-.3.7A3.97,3.97,0,0,0,7.9,10.754Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTools);
export default __webpack_public_path__ + "static/media/icon_tools.baad19e5ac50332af028457fe2e976ba.svg";
export { ForwardRef as ReactComponent };